<script>
    import R, {LOADER} from "../lib/requests";
    import {CHECKIN_STATUS} from "../lib/constants.js";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import PageNotFound from "../components/pages/PageNotFound.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import CheckInData from "./CheckInData.svelte";

    let hash;
    let checkin = null;
    let member = null;
    let hotel = null;
    let errorMessage = null;
    let checkinStatusId = null;

    const load = () => {
        const onSuccess = result => {
            checkin = result;
            member = checkin.member;
            hotel = checkin.hotel;
        }

        const onFailure = err => {
            errorMessage = "check in request not found!";
        };

        R.handle(R.checkin.request, hash, onSuccess, onFailure, LOADER.PAGE);
    }

    const onConfirm = () => {
        Alert.confirm("Confirm check in", `Confirm check in from member ${member.lastname} ${member.firstname}?`, confirm);
    }

    const confirm = () => {
        const onSuccess = result => {
            checkinStatusId = CHECKIN_STATUS.CONFIRMED;
            checkin.points = result.points;
            Notifier.showMessage("Check in confirmed");
        }

        const onFailure = err => {
            if (err.code === 'not_found') {
                if (err.param === 'checkin') {
                    Alert.warning("Confirm check in", "Could not find check in data!");
                    return;
                }
                if (err.param === 'hotel') {
                    Alert.warning("Confirm check in", "Could not find hotel!");
                    return;
                }
                if (err.param === 'points') {
                    Alert.warning("Confirm check in", "Hotel does not has checkin points!");
                    return;
                }
            }
            if (err.code === 'overlap') {
                Alert.warning("Confirm check in", "There is already a confirmed check in of this member on these dates!");
            }
        };

        let data = {
            hash,
            date_in: checkin.date_in,
            date_out: checkin.date_out,
        }

        R.handle(R.checkin.confirm, data, onSuccess, onFailure, LOADER.POPUP);
    }

    const onRefuse = () => {
        Alert.confirm("Reject check in", `Reject check in from member ${member.lastname} ${member.firstname}?`, refuse);
    }

    const refuse = () => {
        const onSuccess = result => {
            checkinStatusId = CHECKIN_STATUS.REFUSED;
            Notifier.showMessage("Check in rejected");
        }

        const onFailure = err => {
            if (err.code === 'not_found') {
                Alert.warning("Reject check in", "Could not find check in data!");
            }
        };

        R.handle(R.checkin.refuse, hash, onSuccess, onFailure, LOADER.POPUP);
    }

    let searchParams = new URLSearchParams(window.location.search);
    hash = searchParams.get('request');
    if (hash) {
        load();
    } else {
        errorMessage = "Invalid request parameters!"
    }
</script>

<div class="container">
    <h1 class="text-center mt-4 mb-4">Checkin Request</h1>

    {#if checkin}
        <div class="text-center">
            <h2 class=" text-gray mb-2">{ hotel.name }</h2>
            <h5 class="text-gray mb-4">{ member.lastname } { member.firstname }</h5>
        </div>
        <div class="row">
            <div class="col-xl-3 col-lg-1"></div>
            <div class="col-xl-6 col-lg-10 col-md-12">
                <CheckInData bind:checkin="{checkin}"/>

                {#if checkinStatusId == null}
                    <div class="text-end">
                        <button class="btn btn-danger" on:click={ onRefuse }>REJECT</button>
                        <button class="btn btn-primary px-4 ms-3" on:click={ onConfirm }>CONFIRM</button>
                    </div>
                {:else if checkinStatusId == CHECKIN_STATUS.CONFIRMED}
                    <div class="alert alert-info alert-with-icon mb-4">
                        <div class="alert-icon">
                            <AppIcon icon="check" strokeWidth="2" size="24"/>
                        </div>
                        <div class="alert-content">
                            Check in has been confirmed!<br>
                            { checkin.points } points added to member.
                        </div>
                    </div>
                {:else if checkinStatusId == CHECKIN_STATUS.REFUSED}
                    <div class="alert alert-danger alert-with-icon mb-4">
                        <div class="alert-icon">
                            <AppIcon icon="x" strokeWidth="2" size="24"/>
                        </div>
                        <div class="alert-content">
                            Check in has been rejected!
                        </div>
                    </div>
                {/if}
            </div>
        </div>
    {/if}
    {#if errorMessage}
        <PageNotFound message="{ errorMessage }"/>
    {/if}
</div>